module.exports = __webpack_public_path__ + "mall_bg.af14ad78.png";